
  const usages = {
    vitamines: {
      color:'#C0392B', bodyLabel:"Vitamines &amp;<br>compléments",
      eyebrow:'Usage 1 sur 5', title:"Vitamines &amp; compléments",
      desc:"Préparez vos prises du jour à l'avance. Cases Matin / Soir / Autre à cocher, étiquette Nom et Jour pour ne plus jamais confondre.",
      list:["Étanche et refermable","Étiquette personnalisable","Format compact voyage"],
      photo:true, photoSrc:'//pillhaven.com/cdn/shop/t/31/assets/pockiva-image-04.png?v=128547417832005963151791759280', photoAlt:"Pochette à pilules Vitamines et compléments"
    },
    bijoux: {
      color:'#7FA363', bodyLabel:"Bijoux",
      eyebrow:'Usage 2 sur 5', title:"Bijoux",
      desc:"Bagues, boucles d'oreilles, bracelets : gardez vos bijoux ensemble et visibles, sans qu'ils s'emmêlent au fond d'un sac.",
      list:["Matière transparente douce","Idéal pour le voyage","Protège des rayures"],
      photo:true, photoSrc:'//pillhaven.com/cdn/shop/t/31/assets/pockiva-image-11.png?v=59267078319991353871791759280', photoAlt:"Pochettes à bijoux Pockiva : boucles d'oreilles, bagues, bracelets, perles"
    },
    epingles: {
      color:'#2E5C8A', bodyLabel:"Épingles à<br>cheveux",
      eyebrow:'Usage 3 sur 5', title:"Épingles &amp; accessoires cheveux",
      desc:"Pinces, épingles, barrettes : terminé les fouilles interminables dans le tiroir de la salle de bain.",
      list:["Compartiment dédié","Fermeture zip anti-perte","Facile à identifier"],
      photo:true, photoSrc:'//pillhaven.com/cdn/shop/t/31/assets/pockiva-image-12.png?v=117175868141707867691791759280', photoAlt:"Pochette à pilules avec épingles à cheveux Bobby Pins"
    },
    accessoires: {
      color:'#3A9188', bodyLabel:"Petits<br>accessoires",
      eyebrow:'Usage 4 sur 5', title:"Petits accessoires du quotidien",
      desc:"Trombones, élastiques, petites fournitures : chaque objet a enfin sa place attitrée.",
      list:["Polyvalent","Résistant à l'usage quotidien","Se glisse partout"],
      photo:true, photoSrc:'//pillhaven.com/cdn/shop/t/31/assets/pockiva-image-13.jpg?v=181225531413679203731791759280', photoAlt:"Pochette à accessoires du quotidien remplie de trombones, élastiques et petites fournitures"
    },
    monnaie: {
      color:'#2B2B2B', bodyLabel:"Pièces de<br>monnaie",
      eyebrow:'Usage 5 sur 5', title:"Pièces de monnaie",
      desc:"Centralisez votre monnaie pour le parcmètre, la boulangerie ou le péage, sans qu'elle traîne au fond du sac.",
      list:["Fermeture sécurisée","Format poche","Facile à vider"],
      photo:true, photoSrc:'//pillhaven.com/cdn/shop/t/31/assets/pockiva-image-14.jpg?v=127223500063375599231791759280',
      photoAlt:"Organisateur Pockiva avec pochettes transparentes contenant des pièces de monnaie"
    }
  };

  const tabs = document.querySelectorAll('.usage-tab');
  tabs.forEach(tab=>{
    tab.addEventListener('click', ()=>{
      tabs.forEach(t=>t.classList.remove('active'));
      tab.classList.add('active');
      const u = usages[tab.dataset.usage];
      const pouchEl = document.getElementById('pouchVisual');
      const photoEl = document.getElementById('usagePhoto');
      if(u.photo){
        pouchEl.style.display = 'none';
        photoEl.style.display = 'block';
        photoEl.src = u.photoSrc;
        photoEl.alt = u.photoAlt;
      } else {
        pouchEl.style.display = 'flex';
        photoEl.style.display = 'none';
      }
      document.getElementById('pouchZip').style.background = u.color;
      document.getElementById('pouchBody').innerHTML = u.bodyLabel;
      document.getElementById('usageEyebrow').textContent = u.eyebrow;
      document.getElementById('usageTitle').innerHTML = u.title;
      document.getElementById('usageDesc').textContent = u.desc;
      document.getElementById('usageList').innerHTML = u.list.map(l=>'<li>'+l+'</li>').join('');
    });
  });

  document.querySelectorAll('.faq-q').forEach(q=>{
    q.addEventListener('click', ()=>{
      const item = q.parentElement;
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i=>i.classList.remove('open'));
      if(!isOpen) item.classList.add('open');
    });
  });

  const swatches = document.querySelectorAll('.variant-swatch');
  swatches.forEach(sw=>{
    sw.addEventListener('click', ()=>{
      swatches.forEach(s=>s.classList.remove('active'));
      sw.classList.add('active');
      document.getElementById('variantName').textContent = sw.dataset.name + ' sélectionné — même prix';
    });
  });
